import styled from "styled-components";

export const EventComponentWrapper = styled.div`
  width: 100%;
  padding: 20px 16px 30px;
`;

export const EventComponentFilter = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;

  > .item {
    height: 30px;
    border-radius: 15px;
    padding: 0 12px;
    line-height: 30px;
    font-weight: 600;
    font-size: 12px;
    border: 1px solid var(--Black-200, #b7b7b7);

    &.selected {
      border: 1px solid #6436e7;
      background: #6436e7;
      color: #fff;
    }
  }
`;

export const EventComponentListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 12px;
`;

export const EventComponentItemWrapper = styled.div`
  cursor: pointer;
  width: 100%;
  position: relative;

  > img {
    border-radius: 8px;
    width: 100%;
  }
`;
